import { render, staticRenderFns } from "./BaseVerticalContainer.vue?vue&type=template&id=f1c1154a"
import script from "./BaseVerticalContainer.vue?vue&type=script&lang=js"
export * from "./BaseVerticalContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports